<template>
  <div class="landing-page-list">
    <h4 class="main-header">{{ $t('navigation_landing_pages') }}</h4>
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">
              Name
            </th>
            <th class="text-left">
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="landingPage in landingPages" :key="`landing-page-${landingPage.id}`">
            <td>{{ landingPage.name }}</td>
            <td>
              <v-btn color="primary" icon @click="goToLandingPage(landingPage.id)">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
  name: 'LandingPagesList',
  computed: {
    ...mapGetters(['landingPagesLoaded', 'landingPages'])
  },
  methods: {
    goToLandingPage (id) {
      this.$router.push({ name: 'landing-page.edit', params: { id: id } })
    }
  },
  created () {
    if (!this.landingPagesLoaded) {
      this.$store.dispatch('loadLandingPages')
    }
  }
}

</script>

<style lang="sass" scoped>

</style>
